module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "open-app"
  }, [_c('touch', {
    on: {
      "tap": _vm.openApp
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTip),
      expression: "showTip"
    }],
    staticClass: "lls-open-app-cover"
  }, [_c('touch', {
    staticClass: "tip",
    on: {
      "tap": _vm.closeTip
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("点击右上角，通过浏览器"), _c('br'), _vm._v("方式立即打开流利说")]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.llscdn.com/fe-static/lingome-wx/right-up-corner@2x-OWgdzdWl.png"
    }
  })])])], 1), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iframeLink),
      expression: "iframeLink"
    }],
    staticClass: "open",
    attrs: {
      "src": _vm.iframeLink,
      "frameborder": "0"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-1badccc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/OpenApp.vue
// module id = 200
// module chunks = 0